<template>
  <div class="invitation">
    <!--导航栏-->
    <header-nav></header-nav>
    <!--个人中心导航-->
    <user-nav></user-nav>

    <div class="user-center">
      <el-tabs class="border-card-main" type="border-card">
        <el-tab-pane label="邀请好友">
          <div class="content">
            <div class="invitation-title">邀请好友: <span class="invitation-qty">（您已成功邀请 0 人）</span></div>

            <div class="invitation-step noSelect">
              <div class="step-item">
                <img class="step-icon" :src="IMG_URL + 'images/invitation/step1.png'" alt="" />
                <p class="invitation-text">1.分享链接给好友</p>
              </div>
              <img class="next-icon" :src="IMG_URL + 'images/invitation/next.png'" alt="" />
              <div class="step-item">
                <img class="step-icon" :src="IMG_URL + 'images/invitation/step2.png'" alt="" />
                <p class="invitation-text">2.好友注册，并下单成功</p>
              </div>
              <img class="next-icon" :src="IMG_URL + 'images/invitation/next.png'" alt="" />
              <div class="step-item">
                <img class="step-icon" :src="IMG_URL + 'images/invitation/step3.png'" alt="" />
                <p class="invitation-text">3.您将获得佣金奖励</p>
              </div>
            </div>

            <div class="invitation-link-main">
              <div class="invitation-h1">专属链接</div>
              <div class="invitation-link-tips">复制下方链接分享给好友，获得更多奖励</div>

              <div class="invitation-link">
                <span class="link" @click="copy">{{ invite_salt }}</span>
                <div :data-clipboard-text="invite_salt" class="clone-btn" @click="copy">复制链接</div>
              </div>
            </div>

            <div class="invitation-table">
              <div class="invitation-h1">推荐列表</div>
              <el-table v-loading="loadingData" :data="tableData" height="400px" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" style="width: 100%">
                <el-table-column label="注册时间">
                  <template slot-scope="scope">
                    <span>{{ scope.row.jointime | formatDate }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="账户名">
                  <template slot-scope="scope">
                    <span>{{ scope.row.nickname }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="手机号码">
                  <template slot-scope="scope">
                    <span>{{ scope.row.mobile }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="会员级别">
                  <template slot-scope="scope">
                    <span>{{ scope.row.level_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="reward" label="累积奖励" />
                <el-table-column label="TA的团队">
                  <template slot-scope="scope">
                    <span>{{ scope.row.qty }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="totalCount > 0" class="page-box">
                <el-pagination
                  :page-size="param.limit"
                  :total="totalCount"
                  :page-sizes="[100, 200, 300, 400]"
                  layout="prev, pager, next,total,sizes,jumper"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--底部-->
    <footer-box></footer-box>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import headerNav from "@/components/headerNav/index";
import userNav from "@/components/userNav/index";
import footerBox from "@/components/footerBox/index";
import { apiInviteGet } from "@/api/api";
export default {
  name: "invitation",
  components: { headerNav, userNav, footerBox },
  data() {
    return {
      tableData: [],
      loadingData: false,
      totalCount: 0,
      param: {
        page: 1,
        limit: 20,
      },
    };
  },
  filters: {
    formatDate: function(time) {
      if (!time) {
        return "-";
      }
      time = time * 1000;
      var re = /-?\d+/;
      var m = re.exec(time);
      if (!m) return "-";
      var d = new Date(parseInt(m[0]));
      var o = {
        "M+": d.getMonth() + 1, // month
        "d+": d.getDate(), // day
        "h+": d.getHours(), // hour
        "m+": d.getMinutes(), // minute
        "s+": d.getSeconds(), // second
        "q+": Math.floor((d.getMonth() + 3) / 3), // quarter
        S: d.getMilliseconds(), // millisecond
      };
      var format = "yyyy-MM-dd";
      if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (d.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
          format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
      }
      return format;
    },
  },
  computed: {
    invite_salt() {
      return location.origin + "/#/login?u=" + this.$store.getters.user_info.salt;
    },
  },
  mounted(e) {
    this.loadData();
  },
  methods: {
    copy() {
      var that = this;
      var clipboard = new Clipboard(".clone-btn");
      clipboard.on("success", e => {
        that.$message.success("复制成功"); // 这里你如果引入了elementui的提示就可以用，没有就注释即可
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", e => {
        // 不支持复制
        console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    handleSizeChange(val) {
      this.param.limit = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.param.page = val;
      this.loadData();
    },
    loadData() {
      this.loadingData = true;
      apiInviteGet(this.param).then(res => {
        this.tableData = res.data.data;
        this.totalCount = res.data.total;
        this.loadingData = false;
      });
    },
  },
};
</script>

<style>
.el-tabs--border-card {
  border: none;
  box-shadow: none;
}

.el-tabs__item {
  padding: 0 60px !important;
}

.el-tabs--border-card > .el-tabs__header {
  background-color: #e4e4e4;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item:hover {
  color: #000000 !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #000;
}

.el-table th {
  background-color: #0f375a;
  color: #ffffff;
  font-size: 12px;
  font-weight: bold;
  border: none;
}

.el-table td {
  color: #000000;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
.invitation {
  min-height: 100vh;
  position: relative;
  padding-bottom: 80px;
  // background-color: #eeeeee;

  .user-center {
    width: 1300px;
    margin: 0 auto;
    padding-left: 180px;

    .border-card-main {
      min-height: calc(100vh - 270px);

      .content {
        padding: 20px;

        .invitation-h1 {
          font-size: 16px;
          color: #0f375a;
          font-weight: bold;
          margin-bottom: 10px;
        }
        .invitation-title {
          font-weight: bold;
          font-size: 14px;

          .invitation-qty {
            color: #0f375a;
          }
        }

        .invitation-step {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 50px 0 30px;

          .step-item {
            .step-icon {
              height: 128px;
              width: auto;
            }
            .invitation-text {
              text-align: center;
              color: #0f375a;
            }
          }
          .next-icon {
            height: 32px;
            width: auto;
          }
        }

        .invitation-link-main {
          margin-bottom: 50px;

          .invitation-link-tips {
            font-size: 12px;
            color: #919191;
            margin-bottom: 20px;
          }

          .invitation-link {
            margin: 20px 0 30px;
            border: 1px solid #e6e6e6;
            height: 40px;
            width: 600px;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .link {
              flex: 1;
              display: block;
              font-size: 16px;
              text-align: left;
              padding-left: 15px;
              color: #0f375a;
            }
            .clone-btn {
              width: 120px;
              height: 100%;
              background-color: #0f375a;
              color: #fff;
              font-size: 14px;
              font-weight: bold;
              text-align: center;
              line-height: 40px;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invitation/index.vue